import Link from "next/link"

function ZeroDaysFooterCTA({ blok }) {
  return <div className='bg-[linear-gradient(to_right,_#E5E4F9_0%,_#EFD1F2_100%)] py-[44px] flex flex-col lg:flex-row gap-[40px] justify-center items-center w-full'>
      <img src={blok?.icon?.filename} className="object-contain" />
      <h2 className="font-aileron text-[28px] text-center lg:text-start lg:text-[40px] 
                                                  !font-bold bg-custom-radial bg-clip-text 
                                                  text-transparent px-4 lg:px-0 ">
        {blok?.text}
      </h2>
      <Link href={"/"+blok?.buttonLink?.cached_url} className='px-[50px] text-[24px] flex justify-center items-center py-[17.5px] gap-2 w-auto h-auto text-white bg-[#E56717] rounded-[4px]'>
        {blok?.buttonText}
      </Link>
    </div>
}

export default ZeroDaysFooterCTA